import { cn } from '@/utils/cn';

interface CheckboxProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  className?: string;
}

export const Checkbox = ({ checked = false, onChange, className }: CheckboxProps) => {
  const handleClick = () => {
    onChange?.(!checked);
  };

  return (
    <div className={cn('flex', className)}>
      <div
        className={cn(
          'relative w-5 h-5 rounded border-1 cursor-pointer transition-all duration-200',
          'flex items-center justify-center',
          checked
            ? 'bg-selected-border border-selected-border'
            : 'bg-white border-base-border hover:border-selected-border'
        )}
        onClick={handleClick}
      >
        {checked && (
          <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={3}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        )}
      </div>
    </div>
  );
};
